import React, { useEffect, useState, useRef } from "react"
import Button from "@/components/core/Button/Button"
import Input from "@/components/core/Input/Input"
import Timers from "@/components/Shared/SignUp/v1/AuthOTP/Timers"
import { validNumber, validPhone } from "@/utils/validate"
import { activateUserFactor, registerUserOKTA } from "utils/userAuth"
import TimersNew from "@/components/Shared/SignUp/v1/AuthOTP/TimersNew"
import Styles from "./index.module.scss"
import { phoneFormat } from "@/utils/helper"
import { Trans } from "next-i18next"
import { useDispatch } from "react-redux"
import {
  clearPreviousToken,
  validateOTP,
  getOTP as getOtpFromExistingUser,
  validateOTPWithoutLogin,
} from "@/store/features/authSlice"
import {
  descriptionClickAnalytics,
  resendOTPAnalytics,
  verifyOTPAnalytics,
} from "../v1/checkoutAnalytics"
import { getAnonymousId } from "@/utils/helper"
import { mergeCart } from "@/store/features/cartSlice"
import { isMobile } from "react-device-detect"
import { showCartExpandedView, showToast } from "@/store/features/genericSlice"

const VerifyOTP = props => {
  const {
    mobileData,
    setMobileData,
    staticTexts,
    setGetOTP,
    numberOfTries,
    setNumberOfTries,
    oktaID,
    setOktaID,
    handleVerifiedOTP,
    handleChangeNumber,
    isExistingUser = false,
    showCheckoutModal = () => {},
    otpViaEmail = false,
    isOmnichannel = false,
    handleOtp=()=>{}
  } = props
  const [delayTrigger, setDelayTrigger] = useState(false)
  const [resendEnable, setResendEnable] = useState(false)
  const [delayTriggerTry, setDelayTriggerTry] = useState(false)
  const [reTryEnable, setReTryEnable] = useState(false)
  const [loading, setLoading] = useState(false)
  const TextFieldValue = [...Array(6)]?.map((_, id) => {
    return {
      id: id,
      value: "",
      error: false,
    }
  })

  const [otpText, setOTPText] = useState(TextFieldValue)
  const [verifyError, setVerifyError] = useState(false)
  const [verifyDisable, setVerifyDisable] = useState(false)
  const [invalidOTP, setInvalidOTP] = useState({ error: false, message: "" })
  const [tooManyAttempts, setTooManyAttempts] = useState({
    error: false,
    message: "",
  })
  const [exceededAttempts, setExceededAttempts] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    if (verifyError) {
      const dataTemp = otpText.map((data, id) => {
        return { ...otpText[id], error: true }
      })
      setOTPText(dataTemp)
    } else {
      const dataTemp = otpText.map((data, id) => {
        return { ...otpText[id], error: false }
      })
      setOTPText(dataTemp)
    }
  }, [verifyError])

  const onNameChange = (e, id) => {
    const { value } = e.target
    if (value === "" || validNumber(value)) {
      const dataTemp = [...otpText]
      dataTemp[id] = { ...dataTemp[id], value: value }
      setOTPText(dataTemp)
      setVerifyError(false)
      setInvalidOTP({
        ...invalidOTP,
        error: false,
        message: "",
      })
    }
  }

  const resendOTP = () => {
    if (numberOfTries > 0 && !delayTrigger && resendEnable) {
      setOTPText(TextFieldValue)
      setInvalidOTP({ error: false, message: "" })
      setNumberOfTries(numberOfTries - 1)
      setDelayTrigger(true)
      setResendEnable(false)
      window.sessionStorage.removeItem("okta-transaction-storage")
      resendOTPNumber()
      setVerifyDisable(false)
    } else {
      setDelayTriggerTry(true)
      setReTryEnable(true)
      setVerifyDisable(true)
    }
  }

  const verifyNum = otpText
    .map(data => data?.value)
    .toString()
    .replace(/,/g, "")
  const isVerify = verifyNum.length === 6

  const verifyOTPHandle = async () => {
    verifyOTPNumber()
    // dispatch(setShowCustomerSignup(true))
  }

  const validateOTPNumber = async () => {
    try {
      const data = {
        passCode: verifyNum,
      }
      const payload = {
        data: data,
        userId: oktaID?.userID,
        factorId: oktaID?.referID,
      }
      if (!isOmnichannel) {
        const resp = isExistingUser
          ? await dispatch(
              validateOTP({
                otpEnteredByUser: verifyNum,
                isMobile: isMobile,
                isCheckoutStep: true,
                showCheckoutModal,
              })
            )
          : await activateUserFactor(payload)
        if (resp?.payload?.invalidOTP) {
          return { statusCode: 400 }
        } else if (resp?.payload?.tooManyAttempts) {
          return { statusCode: 409 }
        } else if (resp?.payload === "success" || resp?.status === "ACTIVE") {
          return { statusCode: 200 }
        } else {
          return { statusCode: 500 }
        }
      } else {
        const resp = isExistingUser
          ? await dispatch(
              validateOTPWithoutLogin({
                otpEnteredByUser: verifyNum,
              })
            )
          : await activateUserFactor(payload)
        if (resp?.payload?.invalidOTP) {
          return { statusCode: 400 }
        } else if (resp?.payload?.tooManyAttempts) {
          return { statusCode: 409 }
        } else if (resp?.payload === "success" || resp?.status === "ACTIVE") {
          return { statusCode: 200 }
        } else {
          return { statusCode: 500 }
        }
      }
    } catch (error) {
      if (error?.response?.data?.errorCode === "E0000068") {
        return { statusCode: 400 }
      } else {
        return { statusCode: 404 }
      }
    }
  }

  const verifyOTPNumber = async () => {
    if (isVerify) {
      setLoading(true)
      // const mergeCartPayload = {
      //   anonymousId: getAnonymousId(),
      //   action: "replace",
      // }
      const data = validateOTPNumber()
      data
        .then(async res => {
          setLoading(false)
          const { statusCode } = res
          if (statusCode === 200) {
            handleVerifiedOTP()
            // await dispatch(
            //   showToast({
            //     message:
            //       "Your cart may have been updated. Please review the cart.",
            //     isVisible: true,
            //   })
            // )
            // const onClick = () => {
            //   dispatch(showCartExpandedView(true))
            //   window.scrollTo(0, 1000, { behavior: "smooth" })
            // }
            // if (isMobile) {
            //   await dispatch(
            //     showToast({
            //       message: `Your cart is updated. <a href='#' class="underline" onclick="${onClick()}">Click here</a> to view the items.`,
            //       isVisible: true,
            //     })
            //   )
            // }
            // dispatch(mergeCart(mergeCartPayload))
            setVerifyError(false)
            verifyOTPAnalytics(true)
            setInvalidOTP({
              ...invalidOTP,
              error: false,
              message: "",
            })
            setExceededAttempts(false)
          } else if (statusCode === 400) {
            setVerifyError(true)
            verifyOTPAnalytics()
            setInvalidOTP({
              ...invalidOTP,
              error: true,
              message: staticTexts?.invalidOTP,
            })
            setTooManyAttempts({ error: false, message: "" })
            setExceededAttempts(false)
          } else if (statusCode === 409) {
            setVerifyError(true)
            verifyOTPAnalytics()
            setInvalidOTP({ error: false, message: "" })
            setTooManyAttempts({
              ...tooManyAttempts,
              error: true,
              message: staticTexts?.tryagainmin,
            })
            setDelayTrigger(true)
            setExceededAttempts(true)
            setVerifyDisable(true)
          } else {
            setVerifyError(true)
            verifyOTPAnalytics()
            setInvalidOTP({
              ...invalidOTP,
              error: true,
              message: "Internal Server Error",
            })
            setTooManyAttempts({ error: false, message: "" })
            setExceededAttempts(false)
          }
        })
        .catch(err => {
          setLoading(false)
          verifyOTPAnalytics()
          console.log("Error", err)
        })
    }
  }

  const isValidPhone = !isOmnichannel ? validPhone(mobileData?.value): validPhone(mobileData)

  const getOTP = async () => {
    try {
      const resp = await registerUserOKTA({ number: mobileData?.value })
      const { statusCode, data } = resp
      return { statusCode: statusCode, data: data }
    } catch (error) {
      if (error?.response?.data) {
        const { data, statusCode } = error?.response?.data
        return { statusCode: statusCode, data: data }
      } else {
        return { statusCode: 404, data: {} }
      }
    }
  }

  const resendOTPNumber = async () => {
    if (isValidPhone) {
      resendOTPAnalytics()
      if(!isOmnichannel){
      const data = getOTP()
      data
        .then(res => {
          const { statusCode, data } = res
          if (statusCode === 200) {
            setOktaID({ userID: data?.user?.id, referID: data?.userFactor?.id })
            setGetOTP(true)
          } else if (statusCode === 400) {
            dispatch(clearPreviousToken())
            dispatch(
              getOtpFromExistingUser({ mobileNumber: mobileData?.value })
            )
              .then(res => {
                setLoading(false)
                setGetOTP(true)
              })
              .catch(err => console.log("error", err))
          } else {
            setMobileData({
              ...mobileData,
              error: true,
              message: "Internal Server Error",
            })
          }
        })
        .catch(error => {
          console.log("Error", error)
        })
      }
      else{
        handleOtp()
      }
    }
  }
  useEffect(() => {
    document.getElementById(`contact-user-phone-0`) &&
      document.getElementById(`contact-user-phone-0`).focus()
  }, [document.getElementById(`contact-user-phone-0`)])

  const termsRef = useRef(null)

  useEffect(() => {
    // to add analytics for terms and policy links
    const links = termsRef.current.querySelectorAll("a")
    Array.from(links).forEach(link => {
      link.addEventListener("click", () =>
        descriptionClickAnalytics(link.innerText, link.getAttribute("href"))
      )
    })
  }, [])

  return (
    <div
      className={`${
        !isOmnichannel ? "pl-50 pr-50 mob-pad-lr-0" : "padding-left-right"
      }`}
    >
      <div className={Styles.authOTPModalWrapper}>
        <div className="auth-otp-modal__container">
          <h2 className="auth-otp-modal__title">
            {staticTexts?.verificationTitle}
          </h2>
          {!otpViaEmail ? (
            <div className="auth-otp-modal__enterOTPText">
              {`Enter the six-digit code sent to your mobile device at
             +91 ${
               !isOmnichannel ? mobileData?.value : mobileData
             } and then click “Verify” to complete one-time password verification.`}
            </div>
          ) : (
            <div className="auth-otp-modal__enterOTPText">
              {`A six digit OTP has been sent to the email address associated with +91 ${mobileData?.value}`}
            </div>
          )}
          <span
            className="auth-otp-modal__backToSignInText"
            onClick={() => {
              handleChangeNumber()
              setExceededAttempts(false)
            }}
          >
            {staticTexts?.changeNumber}
          </span>
          <div className="auth-otp-modal__verify">
            {otpText.map((data, id) => {
              return (
                <Input
                  key={data?.id}
                  customClass="auth-otp-modal__input-field"
                  id={`contact-user-phone-${data?.id}`}
                  type="tel"
                  name={`verifytext-${data?.id}`}
                  value={data?.value}
                  onChange={e => onNameChange(e, id)}
                  onKeyDown={e => {
                    if (
                      (e.key === "Delete" || e.key === "Backspace") &&
                      e.target.value === ""
                    ) {
                      if (id > 0) {
                        document
                          .getElementById(`contact-user-phone-${id - 1}`)
                          .focus()
                      }
                    }
                  }}
                  onKeyUp={e => {
                    if (e.target.value !== "") {
                      if (id >= 0 && id < 5) {
                        document
                          .getElementById(`contact-user-phone-${id + 1}`)
                          .focus()
                      }
                    }
                  }}
                  disabled={verifyDisable}
                  maxLength="1"
                  showError={data?.error}
                />
              )
            })}
          </div>
          <div className="auth-otp-modal__content">
            {invalidOTP?.error && (
              <p className="auth-otp-modal__verify-error">
                {invalidOTP?.message}
              </p>
            )}
            {/* {tooManyAttempts?.error && (
              <p className="auth-otp-modal__timer">
                {tooManyAttempts?.message}
              </p>
            )} */}
            {reTryEnable && (
              <TimersNew
                staticTexts={staticTexts}
                setNumberOfTries={setNumberOfTries}
                delayTriggerTry={delayTriggerTry}
                setDelayTriggerTry={setDelayTriggerTry}
                setReTryEnable={setReTryEnable}
                mobileData={mobileData}
                setResendEnable={setResendEnable}
                setVerifyDisable={setVerifyDisable}
                resetError={() => setOTPText(TextFieldValue)}
                setExceededAttempts={setExceededAttempts}
                setDelayTrigger={setDelayTrigger}
                exceededAttempts={exceededAttempts}
              />
            )}
            {exceededAttempts && (
              <TimersNew
                staticTexts={staticTexts}
                setNumberOfTries={setNumberOfTries}
                delayTriggerTry={delayTriggerTry}
                setDelayTriggerTry={setDelayTriggerTry}
                setReTryEnable={setReTryEnable}
                mobileData={mobileData}
                delayResend="300"
                tryAgaininmin={true}
                setExceededAttempts={setExceededAttempts}
                setResendEnable={setResendEnable}
                setVerifyDisable={setVerifyDisable}
                resetError={() => setOTPText(TextFieldValue)}
                setDelayTrigger={setDelayTrigger}
                exceededAttempts={exceededAttempts}
              />
            )}
            {!resendEnable && !reTryEnable && !exceededAttempts && (
              <Timers
                delayTrigger={delayTrigger}
                setDelayTrigger={setDelayTrigger}
                setResendEnable={setResendEnable}
              />
            )}

            {resendEnable && !reTryEnable && (
              <p className="auth-otp-modal__receive">
                {staticTexts?.receiveOTP}{" "}
                <span className={`enable`} onClick={resendOTP}>
                  {staticTexts?.resend}
                </span>
              </p>
            )}
          </div>
          <Button
            type="black"
            role="button"
            ariaLabel={staticTexts?.verify}
            flexible={true}
            label={staticTexts?.verify}
            onClick={verifyOTPHandle}
            loading={loading}
            disabled={!isVerify || exceededAttempts || reTryEnable}
          />
          <div className="auth-otp-modal__terms" ref={termsRef}>
            {staticTexts?.createAccountPrivacyPolicy}
          </div>
        </div>
      </div>
    </div>
  )
}
export default VerifyOTP
